import script from "./categoryTab.vue?vue&type=script&setup=true&lang=js"
export * from "./categoryTab.vue?vue&type=script&setup=true&lang=js"

import "./categoryTab.vue?vue&type=style&index=0&id=265d4756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265d4756"]])

export default __exports__